<template class="flex-grow-1">
    <div class="m-5 p-5">
        <div>{{ message }}</div>
        <div class="d-flex mb-3">
            <b-form-input v-model="idSubstring" placeholder="Поиск по ID" class="mr-2"></b-form-input>
            <b-button @click="clearIdFilter" variant="danger" size="sm" v-show="idSubstring" class="ml-1">
                Сбросить
            </b-button>
            <b-button @click="searchById" variant="primary" class="ml-2">Поиск</b-button>
        </div>
        <div v-show="tableVisible">
            <b-table id="generation-projects" :items="itemsProvider" :fields="fields" bordered striped
                :per-page="perPage" :current-page="currentPage" ref="table">
                <template v-slot:head(state)="data">
                    {{ data.label }}
                    <b-form-select v-model="selected" :options="states" @change="stateChanged"></b-form-select>
                </template>
                <template v-slot:cell(actions)="row">
                    <b-button size="sm" @click="updatePriority(row.item)" class="btn-primary mr-1"
                        v-if="isRunningOrQueued(row)">
                        Поставить максимальный приоритет
                    </b-button>
                    <b-button size="sm" @click="cancelProject(row.item)" class="btn-danger mr-1"
                        v-if="isRunningOrQueued(row)">
                        Отменить генерацию
                    </b-button>
                    <b-button size="sm" @click="openInNewTab(row.item)" v-if="isCompleted(row)" class="btn-info mr-1">
                        Открыть результат
                    </b-button>
                </template>
            </b-table>
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                aria-controls="generation-projects"></b-pagination>
        </div>
    </div>
</template>

<script>

import MapAPI from "../mixins/MapAPI.js";

const statesArr = [
    "ALL",
    "QUEUED",
    "RUNNING",
    "COMPLETED",
    "ERROR",
    "CANCELLED",
    "QUEUED, RUNNING"
]

export default {
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            rows: 0,
            idSubstring: '',
            fields: [
                { key: "id", label: "ID" },
                { key: "state", label: "Статус" },
                { key: "lastUpdateDate", label: "Последнее обновление" },
                { key: "createdTimestamp", label: "Время создания" },
                { key: "completedTimestamp", label: "Время окончания" },
                { key: "priority", label: "Приоритет" },
                { key: "actions", label: "Действия" },
            ],
            tableVisible: true,
            allOkMessage: "Управление очередью проектов",
            notOkMessage: "У вас нет прав для работы с данной страницей",
            message: this.allOkMessage,
            states: statesArr,
            selected: statesArr[0]
        };
    },
    methods: {
        clearIdFilter() {
            this.idSubstring = '';
            this.currentPage = 1;
            this.$refs.table.refresh();
        },
        searchById() {
            this.currentPage = 1;
            this.$refs.table.refresh();
        },
        isRunningOrQueued(row) {
            return row.item.state == "RUNNING" || row.item.state == "QUEUED"
        },
        isRunning(row) {
            return row.item.state == "RUNNING"
        },
        isCompleted(row) {
            return row.item.state == "COMPLETED"
        },
        openInNewTab(item) {
            const { href } = this.$router.resolve({ name: 'result', params: { resultId: item.id } })
            window.open(href, '_blank');
        },
        async itemsProvider(ctx) {
            let requestParams = {
                pageNumber: ctx.currentPage,
                pageSize: ctx.perPage
            }
            var filter = {
                idSubstring: this.idSubstring || undefined,
                states: []
            }
            console.log(this.selected)
            if (this.selected == "ALL") {
                // filter.states остается пустым
            } else if (this.selected == "QUEUED, RUNNING") {
                filter.states.push("RUNNING")
                filter.states.push("QUEUED")
            } else {
                filter.states.push(this.selected)
            }
            let response = await this.findQueuedGenerationProjects(filter, requestParams)

            if (response.data.code === 101) {
                this.tableVisible = false
                this.message = this.notOkMessage
                return
            }

            this.message = this.allOkMessage
            this.rows = response.data.pageInfo.totalCount

            return response.data.pageContent
        },
        async updatePriority(item) {
            if (confirm("Поднять приоритет для проекта с ID " + item.id + "?")) {
                this.updateGenerationProjectPriority(item.id)
                    .then(rz => {
                        console.log(rz.data)
                        this.$refs.table.refresh()
                    })
            }
        },
        async cancelProject(item) {
            if (confirm("Отменить генерацию по проекту с ID " + item.id + "?")) {
                this.cancelGenerationProject(item.id)
                    .then(rz => {
                        console.log(rz.data)
                        this.$refs.table.refresh()
                    })
            }
        },
        stateChanged() {
            this.$refs.table.refresh()
        },
        openResult(item) {
            console.log(item)
        }

    },
    mixins: [MapAPI]
};
</script>

<style scoped></style>
